import { Component, Input, ViewChild, OnInit, Output, EventEmitter, TemplateRef, AfterViewInit, OnChanges, SimpleChanges, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ColumnMode, DatatableComponent, NgxDatatableModule, TableColumn } from '@swimlane/ngx-datatable';
import { NbSidebarService } from '@nebular/theme';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as _ from 'lodash';

export interface CustomAuditLogTableColumnConfig extends TableColumn {
  align?: string;
  bold?: boolean;
  format?: string;
  detail?: boolean;
  customTemplate?: any;
  cellClass?: string;
  textWrap?: boolean;
  minWidth?: number;
}

@Component({
  selector: 'custom-audit-log-table',
  templateUrl: './custom-audit-log-table.component.html',
  styleUrls: ['./custom-audit-log-table.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomAuditLogTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() type: string;
  @Input() rows: any[];
  @Input() cols: CustomAuditLogTableColumnConfig[];
  @Input() columnMode: string;
  @Input() paginationMode: any;
  @Input() pageInfo: any;
  @Input() isReception: boolean;
  @Input() expanded = false;
  @Input() hideShowNumberRows: boolean;
  @Input() scrollbarH: boolean;
  @Input() textHighlight: string = '';
  @Output() clickRow = new EventEmitter<any>();
  @Output() scroll = new EventEmitter<any>();
  @Output() sort = new EventEmitter<any>();
  @Output() resetSort = new EventEmitter<any>();
  @Output() buttonClick = new EventEmitter<any>();
  @Output() changePage = new EventEmitter<any>();
  @Output() changeLimit = new EventEmitter<any>();
  @Output() clickCell = new EventEmitter<any>();
  @Output('getValueExpand') rowExpand = new EventEmitter<any>();

  @ViewChild(DatatableComponent, { static: true }) ngxTable: DatatableComponent;

  ColumnMode = ColumnMode;
  pageSize: number = 10;
  enableCursorRow: boolean = true;
  scrollUpdate$;
  scrollCheck$;
  isScrolling: boolean = false;

  constructor(
    private nbSidebarService: NbSidebarService,
    private router: Router,
    private permissionsService: NgxPermissionsService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.handleLimitItem();
    if (changes.rows && changes.rows.currentValue) {
      this.expendRows();
    }
    if (changes.expanded && this.rows) {
      this.expendRows();
    }

    if (changes.rows && changes.rows.currentValue) {
      // this.rowSelected = _.cloneDeep(this.rows);
      setTimeout(() => {
        this.onRecaculate();
      }, 100)
    }

  }

  private expendRows(): void {
    // if (this.expanded) {
    //   Promise.resolve().then(() => {
    //     this.ngxTable.rowDetail.expandAllRows();
    //   });
    // } else {
    //   Promise.resolve().then(() => {
    //     this.ngxTable.rowDetail.collapseAllRows();
    //   });
    // }

  }

  ngOnInit() {
    this.columnMode = this.columnMode && this.columnMode === "force" ? "force" : "flex";
    this.onRecaculate();
    this.nbSidebarService.onToggle().subscribe(() => {
      this.onRecaculate();
    });
    this.handleCursorRow();

    if (this.isReception) {
      this.scrollCheck$ = interval(30 * 1000).subscribe(() => {
        if (!this.isScrolling) {
          this.isScrolling = true;
          if (this.scrollUpdate$) this.scrollUpdate$.unsubscribe();
          this.scrollUpdate$ = this.updateScrollTimer().subscribe(() => {
            this.updateScrollPosition();
          });
        }
      })
    }


    setTimeout(() => {
      this.onRecaculate();
    }, 100)
  }

  onRecaculate() {
    setTimeout(() => {
      this.checkXScroll();
      this.ngxTable.recalculate();
      // window.dispatchEvent(new Event('resize'));
    }, 200);
  }

  onResize(event) {
    console.log("onResize");
    this.onRecaculate();
  }

  checkXScroll() {
    try {
      const tableWidth = this.ngxTable.element.getElementsByTagName('datatable-body')[0].clientWidth;
      const tableContentWidth = this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollWidth;
      const hasXScroll = this.ngxTable.element.getElementsByTagName('datatable-body')[0].classList.contains('hide-x-scroll');
      if (tableContentWidth <= (tableWidth + 15)) {
        !hasXScroll && this.ngxTable.element.getElementsByTagName('datatable-body')[0].classList.add('hide-x-scroll');
      } else {
        hasXScroll && this.ngxTable.element.getElementsByTagName('datatable-body')[0].classList.remove('hide-x-scroll');
      }
    } catch (error) { }
  }

  onActivate(event) {
    if (event.type == 'click') {
      event.cellElement.blur();
      this.clickRow.emit(event.row);
    }
  }

  handleClickCell(val) {
    this.clickCell.emit(val);
  }

  onScroll(event: number) {
    this.scroll.emit(event);
  }

  onSort(event) {
    this.sort.emit(event);
  }

  onResetSort(sorts: any[] = []) {
    this.ngxTable.sorts = sorts;
  }

  scrollToTop() {
    this.ngxTable.offset = 0;
  }

  handleCursorRow() {
    this.enableCursorRow = false;
  }

  toggleExpandRow(row, e, expanded) {
    this.rowExpand.emit({ row: row, event: e, expanded: expanded })
    e.stopPropagation();
    this.ngxTable.rowDetail.toggleExpandRow(row);
  }

  assignButton(row, e) {
    this.buttonClick.emit({ row: row, event: e });
  }

  setPage(event) {
    this.changePage.emit(event);
  }

  setLimitItem(limit) {
    this.changeLimit.emit(limit);
  }

  handleLimitItem() {
    if (this.paginationMode) {
      this.pageSize = this.pageInfo && this.pageInfo.limit ? this.pageInfo.limit : this.pageSize;
    } else {
      this.pageSize = undefined;
    }
  }

  getRowClass(row) {
    const showOverTime = !row.isReception && row.isOverTime;
    return {
      'has-hrefLink': !!row.hrefLink,
      'over-time': showOverTime,
      'normal': !showOverTime,
      'rowDisabled': row.rowDisabled,
    };
  }

  updateScrollTimer() {
    return interval(2 * 1000).pipe(takeWhile(() => this.isScrolling));
  }

  updateScrollPosition() {
    const scrollTop = this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollTop;
    const clientHeight = this.ngxTable.element.getElementsByTagName('datatable-body')[0].clientHeight;
    const scrollHeight = this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollHeight;
    const atBottom = scrollTop + clientHeight >= scrollHeight;

    if (!atBottom) {
      this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollTop = scrollTop + 50;
      this.isScrolling = true;
    } else {
      this.ngxTable.element.getElementsByTagName('datatable-body')[0].scrollTop = 0;
      this.isScrolling = false;
    }
  }

  showTextWithHighlight(value: string | Object) {
    if (!value) return '--';
    if (typeof value === 'string') {
      return this.getHighlightTextWithHtmlTag(value);
    }

    if (typeof value === 'object') {
      const items = Object.keys(value).map((key) => {
        const keyHighlighted = this.getHighlightTextWithHtmlTag(key);
        const valueHighlighted = this.getHighlightTextWithHtmlTag(String(value[key]));

        return `<span class="change-log-item"><span class="change-log-item-key">${keyHighlighted}: </span><span class="change-log-item-value">${valueHighlighted}</span></span>`
      }).join(' ');
      
      return `<span class="change-log-data-list">${items}</span>`;
    }

  }

  getHighlightTextWithHtmlTag(value: string) {
    const textHighlight = this.textHighlight.trim();
    if (!textHighlight) return value;
    const escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    const reg = new RegExp(escapeRegex(textHighlight), 'gi');
    const matchingText = value.match(reg);
    const matchingTextHighlight = matchingText ? matchingText[0] : '';

    return value.replace(reg, `<mark class="px-0">${matchingTextHighlight}</mark>`);
  }

  ngOnDestroy(): void {
    if (this.scrollUpdate$) this.scrollUpdate$.unsubscribe();
    if (this.scrollCheck$) this.scrollCheck$.unsubscribe();
  }
}
